module.exports = __webpack_public_path__ + "static/media/cryptocoins.8e447dff.woff2";